/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsRestSetting
 */
export interface MelcoModelsRestSetting {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsRestSetting
     */
    fulfillment_client_hub?: string | null;
}

export function MelcoModelsRestSettingFromJSON(json: any): MelcoModelsRestSetting {
    return MelcoModelsRestSettingFromJSONTyped(json, false);
}

export function MelcoModelsRestSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsRestSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fulfillment_client_hub': !exists(json, 'fulfillment_client_hub') ? undefined : json['fulfillment_client_hub'],
    };
}

export function MelcoModelsRestSettingToJSON(value?: MelcoModelsRestSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fulfillment_client_hub': value.fulfillment_client_hub,
    };
}


